import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { AutomationViewGroup } from '@tokeet-frontend/automations'

@Component({
  selector: 'app-dialog',
  templateUrl: './automation-logs-dialog.component.html',
  styleUrls: ['./automation-logs-dialog.component.scss'],
})
export class AutomationLogsDialogComponent implements OnInit {
  get automationGroup() {
    return this.data.automationGroup
  }

  constructor(
    public dialogRef: MatDialogRef<AutomationLogsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { automationGroup: AutomationViewGroup }
  ) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close()
  }
}
